<template>
    <div class="commonFormStyles newMaterialPlan-box">
        <HeaderNav
            header-title="交付信息"
            left-icon-name="2"
            right-icon-name="3"
        ></HeaderNav>
        <section class="form-con showFontBtn">
            <van-collapse v-model="activeNames">
                <van-collapse-item name="1" class="">
                    <div slot="title">
                        <span class="iconfont icondanjubianhao"></span>
                        <span class="tit-text">基本信息</span>
                    </div>
                    <div class="form-group">
                        <van-cell-group>
                            <van-cell
                                title="工程名称"
                                :value="formData.project_name"
                                :icon="require('@/assets/images/icons/icon_2.png')"
                            ></van-cell>
                            <van-cell
                                title="施工部位"
                                :value="formData.place_name"
                                :icon="require('@/assets/images/icons/icon_gy_2.png')"
                            ></van-cell>
                            <van-cell
                                title="运输单号"
                                :value="formData.pcb_number"
                                :icon="require('@/assets/images/icons/icon_gy_1.png')"
                            ></van-cell>
                            <van-cell
                                title="到达时间"
                                :value="formData.arrive_time"
                                :icon="require('@/assets/images/icons/icon_gy_7.png')"
                            ></van-cell>
                            <van-cell
                                title="强度等级"
                                :value="formData.strength_grade_name"
                                :icon="require('@/assets/images/icons/icon_gy_3.png')"
                            ></van-cell>
                            <van-cell
                                title="外加剂"
                                :value="formData.special_require_name"
                                :icon="require('@/assets/images/icons/icon_6.png')"
                            ></van-cell>
                            <van-cell
                                title="坍落度"
                                :value="`${formData.slump}±${formData.slump_name}`"
                                :icon="require('@/assets/images/icons/icon_16.png')"
                            ></van-cell>
                        </van-cell-group>
                    </div>
                </van-collapse-item>
            </van-collapse>
            <van-form ref="transSheet" class="form-group">
                <van-cell
                    title="开始卸料时间"
                    :value="formData.unload_time"
                    :icon="require('@/assets/images/icons/icon_gy_7.png')"
                ></van-cell>
                <van-cell
                    title="结束卸料时间"
                    :value="formData.unload_over_time"
                    :icon="require('@/assets/images/icons/icon_gy_7.png')"
                ></van-cell>
                <van-cell
                    title="本车方量"
                    :value="formData.volume"
                    :icon="require('@/assets/images/icons/icon_30.png')"
                ></van-cell>
                <van-cell
                    title="卸料方量"
                    :value="formData.unload_volume"
                    :icon="require('@/assets/images/icons/icon_30.png')"
                >
                </van-cell>
                <van-field
                    readonly
                >
                    <div slot="left-icon">
                        <span class="cell9 cell-icon"></span>
                    </div>
                    <div slot="label">
                        是否剩退灰
                    </div>
                    <template #right-icon>
                        <van-switch :value="formData.is_surplus" size="20px"></van-switch>
                    </template>
                </van-field>
                <van-action-sheet
                    v-model="showSurplus"
                    :actions="surplusActions"
                    @select="selectSurplus"
                    cancel-text="取消"
                    @cancel="onCancel"
                ></van-action-sheet>
            </van-form>
            <div class="upload-con group-item">
                <div class="tit">
                    <span class="iconfont icondingdan"></span>
                    <span>上传资料</span>
                </div>
                <div class="file-list">
                    <template>
                        <van-uploader
                            :after-read="uploadFileMethod"
                            preview-image
                            preview-full-image
                            v-model="fileList"
                            multiple
                            @delete="deleteFile"
                        ></van-uploader>
                    </template>
                </div>
            </div>
            <div class="group-item" style="border-bottom:none;">
                <div class="tit">
                    <span class="iconfont iconpingjia"></span>
                    <span>评价信息</span>
                </div>
                <div class="evaluate">
                    <div class="item" v-for="(item, index) in saveData.evaluateDetails" :key="index">
                        <label>{{ item.option_name }}</label>
                        <van-rate v-model="item.score"></van-rate>
                        <span class="tip" v-if="item.score===5">非常好</span>
                        <span class="tip" v-else-if="item.score===4">好</span>
                        <span class="tip" v-else-if="item.score===3">一般</span>
                        <span class="tip" v-else-if="item.score===2||item.score===1">差</span>
                        <span class="tip" v-else></span>
                    </div>
                </div>
            </div>
            <div class="option-con">
                <span class="iconfont iconbeizhu"></span>
                <textarea
                    placeholder="请在此输入评价信息"
                    v-model="saveData.driver_remark"
                    @focus="inputFocus($event)"
                    @focusout="inputFocusout"
                ></textarea>
            </div>
        </section>
        <footer class="commonFormBtns">
            <van-button type="info" @click="driverEvaluate">
                提交
            </van-button>
        </footer>
    </div>
</template>

<script>
import { HeaderNav } from '@/components/';
import { Toast, ImagePreview } from 'vant';
export default {
    components: {
        HeaderNav,
    },
    props: {},
    data() {
        return {
            activeNames: [],
            formData: {}, // 回显运输单信息
            value: 0,
            saveData: {
                pcb_number: '',
                task_number: '',
                unload_volume: null,
                is_surplus: false,
                evaluateDetails: [
                    {
                        eva_id: '',
                        option_id: '1',
                        option_name: '要料人配合程度',
                        score: 0,
                    },
                    {
                        eva_id: '',
                        option_id: '2',
                        option_name: '工地压车程度',
                        score: 0,
                    },
                    {
                        eva_id: '',
                        option_id: '3',
                        option_name: '施工方用灰规范程度',
                        score: 0,
                    },
                    {
                        eva_id: '',
                        option_id: '4',
                        option_name: '施工方退料情况',
                        score: 0,
                    },
                ], // 评分
                driver_files: '', // 附件
                driver_remark: '',
            },
            fileList: [],
            handleType: '',
            imgUrls: [],
            isIOS: false, // 苹果/安卓手机
            showSurplus: false, // 是否展示剩退灰选项
            surplusActions: [
                { name: '是' },
                { name: '否' },
            ], // 选项
            checked: true,
            aliyunOssToken: '',
            buCode: 'ProductionAffix',
        };
    },
    watch: {},
    computed: {},
    methods: {
        // 上传文件
        async uploadFileMethod() {
            if (this.fileList.length === 0) {
                return;
            }
            // 如果没有文件分组 先创建文件分组
            if (!this.filesGroupId) {
                this.upGroupFun();
            }
            this.$nextTick(() => {
                for (const item of this.fileList) {
                    if (!item.fileId) {
                        this.upGroupFun(item);
                    }
                }
            });
        },
        // 获取上传通行证
        getOssToken() {
            this.$axios.get(this.GLOBAL.FILE_BASE_URL_OSS + `credential/GetPostPolicy/${this.buCode}`).then(res => {
                if (res) {
                    this.aliyunOssToken = res;
                    // localStorage.setItem('aliyunOssToken', JSON.stringify(res));
                }
            });
        },
        // 上传组名
        upGroupFun(val) {
            const filename = val ? val.file.name : '现场照片';
            // 判断是否过期，过期重新调用获取通信证方法
            const formData = new FormData();
            // 注意formData里append添加的键的大小写
            formData.append('key', `${this.aliyunOssToken.dir}${this.pcb_number}/${filename}`); // 存储在oss的文件路径
            formData.append('OSSAccessKeyId', this.aliyunOssToken.accessid); // accessKeyId
            formData.append('policy', this.aliyunOssToken.policy); // policy
            formData.append('Signature', this.aliyunOssToken.signature); // 签名
            // 如果是base64文件，那么直接把base64字符串转成blob对象进行上传就可以了
            formData.append('file', val ? val.file : filename);
            // formData.append('FileDescription', this.newFile.FileDescription);
            formData.append('success_action_status', 200); // 成功后返回的操作码
            formData.append('Content-Type', 'multipart/form-data'); // 成功后返回的操作码

            // 回调参数
            const obj = {
                bucket: this.aliyunOssToken.bucket ? this.aliyunOssToken.bucket : this.buCode, // 存储桶名称
                business_type_code: this.buCode, // 业务类型编码
                object_name: `${this.aliyunOssToken.dir}${this.pcb_number}/${filename}`, // 文件对象名
                show_name: filename, // 显示文件名
                size: 0, // 文件大小
                mimeType: '',
                mime_type: val ? val.file.type : '',
                data_id: this.pcb_number, // 业务数据id
                directory_id: '', // 目录id
                tenant_id: this.$takeTokenParameters('TenantId'), // 租户id
                // FileDescription: this.newFile.FileDescription, // 文件描述
            };
            this.uploadFun(formData, obj, val);
        },
        // 上传文件
        uploadFun(formData, val, file) {
            this.$.ajax({
                url: this.aliyunOssToken.host,
                type: 'POST',
                data: formData,
                cache: false, // 不缓存数据
                processData: false, // 不处理数据
                contentType: false, // 不设置内容类型
                success: data => { // 成功回调
                    this.callBackFun(val, file);
                },
            });
        },
        // 上传的回调
        callBackFun(obj, file) {
            this.$axios.post(this.GLOBAL.FILE_BASE_URL_OSS + 'api/UploadCallback', obj).then(res => {
                if (res) {
                    this.saveData.driver_files += res.id + ',';
                    if (file) {
                        file.fileId = res.id;
                    } else {
                        this.filesGroupId = res.id;
                    }
                }
            });
        },
        afterRead(file) {
            // 此时可以自行将文件上传至服务器
            this.uploadFile(file);
        },
        // 获取司机运输单
        getDriverPcb(pcb_number) {
            this.$axios
                .get('/interfaceApi/production/productpcb/get_driver_pcb?pcb_number=' + pcb_number)
                .then(res => {
                    if (res) {
                        this.formData = res;
                        if (this.formData.is_surplus === 1) {
                            this.formData.is_surplus = true;
                        } else {
                            this.formData.is_surplus = false;
                        }
                    }
                })
                .catch(error => {
                    this.$toast(error.Errorcode.Message);
                });
        },
        // 图片预览
        imageView(index) {
            ImagePreview({ images: this.imgUrls, startPosition: index });
        },
        // 删除上传的附件
        deleteFile(file, row) {
            const _that = this;
            const ids = this.saveData.driver_files.split(',');
            ids.splice(row.index, 1);
            this.saveData.driver_files = ids.join(',') + ',';
            this.fileList.splice(row.index, 1);
            if (file.fileId) {
                this.$axios
                    .delete(this.GLOBAL.FILE_BASE_URL_OSS + 'api/DeleteFileInfo/' + file.fileId, {
                    })
                    .then(() => {
                        _that.$message({
                            message: '删除成功！',
                            type: 'success',
                        });
                    })
                    .catch(error => {
                        _that.$message.error(error.ErrorCode.Message);
                    });
            }
        },
        // 司机评价
        driverEvaluate() {
            this.$refs.transSheet.validate().then(res => {
                this.saveData.pcb_number = this.formData.pcb_number;
                this.saveData.task_number = this.formData.task_number;
                this.saveData.unload_volume = this.formData.unload_volume;
                if (this.formData.is_surplus) {
                    this.saveData.is_surplus = 1;
                } else {
                    this.saveData.is_surplus = 2;
                }

                this.$axios
                    .post('/interfaceApi/production/productpcb/driver_evaluate', this.saveData)
                    .then(res => {
                        if (res) {
                            // this.surplus();
                            Toast.success('操作成功');
                            this.$router.isBack = 1;
                            this.$router.go(-1);
                        }
                    })
                    .catch(error => {
                        this.$toast(error.Errorcode.Message);
                    });
            }).catch(() => {
            });

        },
        // 拉取司机评价
        getDriverEvaluate() {
            this.$axios
                .get('/interfaceApi/production/productpcb/get_driver_evaluate?pcb_number=' + this.pcb_number)
                .then(res => {
                    if (res) {
                        this.saveData = res;
                        if (this.saveData.driver_files) {
                            let fileStr = this.saveData.driver_files;
                            const comma = fileStr.charAt(fileStr.length - 1);
                            if (comma === ',') {
                                fileStr = fileStr.substring(0, fileStr.length - 1);
                            }
                            const fileArr = fileStr.split(',');
                            fileArr.map(item => {
                                this.getFileDetailFun(item);
                            });
                        }
                        if (this.saveData.is_surplus === 1) {
                            this.saveData.is_surplus = true;
                        } else {
                            this.saveData.is_surplus = false;
                        }
                    }
                })
                .catch(error => {
                    this.$toast(error.Errorcode.Message);
                });
        },
        // 获取文件下载预览地址
        getFileDetailFun(item) {
            this.$axios
                .get(this.GLOBAL.FILE_BASE_URL_OSS + 'api/GetFileInfo/' + item)
                .then(res => {
                    const url = res.preview_url;
                    const json = { url: url, isImage: true };
                    this.fileList.push(json);
                })
                .catch(error => {
                    this.$message.error(error.ErrorCode.Message);
                });
        },
        // 展示电子运单
        toElectronicTicket(data) {
            this.$router.isBack = 2;
            this.$router.push({ name: 'electronicTicket', params: { pcb_number: data.pcb_number } });
        },
        // 文本域在手机端输入完空白问题
        inputFocus() {
            clearTimeout(this.timer);
        },
        inputFocusout() {
            this.timer = setTimeout(() => {
                window.scrollTo(0, 0);
                // 间隔设为10，减少页面失去焦点定时器的突兀感，
            }, 10);
        },
        // 取消展示剩退灰选项
        onCancel() {
            this.showSurplus = false;
        },
        // 剩退灰选择事件
        selectSurplus(item) {
            this.showSurplus = false;
            this.formData.is_surplus = item.name;
        },
        // 剩退灰
        surplus() {
            this.$axios
                .put('/interfaceApi/production/productpcb/surplus/' + this.pcb_number + '/' + this.saveData.is_surplus)
                .then(res => {
                }).catch(err => {
                    this.$toast(err.Errorcode.Message);
                });
        },
    },
    created() {

    },
    mounted() {
        const aliy = localStorage.getItem('aliyunOssToken') ? JSON.parse(localStorage.getItem('aliyunOssToken')) : null;
        const date = new Date();
        if (aliy && aliy.expire && aliy.expire * 1000 > date.getTime()) {
            this.aliyunOssToken = aliy;
        } else {
            this.getOssToken();
        }
        this.pcb_number = this.$route.params.pcb_number;
        this.getDriverPcb(this.pcb_number);
        this.getDriverEvaluate();
    },
};
</script>
<style lang="stylus">
.newMaterialPlan-box
    height calc(100% - 44rpx)
    .hader-nav
        position initial
    .form-con
        height 100%
        overflow-y auto
        overflow-x hidden
        .icondanjubianhao
            font-size 18rpx
            margin-right 10rpx
            float left
            color #666
        .tit-text
            float left
        .view-electronic
            float right
            color #E60000
        .van-form
            .van-cell
                padding 0
        .van-collapse-item__content
            padding 0 0 0 0
        .van-cell__title
            font-size 14rpx
        .van-collapse-item__title--expanded
            .van-cell__title
                color #3495FB
                .icondanjubianhao
                    color #3495FB
        .form-group
            .van-cell
                padding 10rpx 10rpx 10px 16rpx;
                font-size 14rpx
            .van-field__control
                text-align right
            .cell-icon
                width 16rpx
                height 16rpx
                display inline-block
                background-repeat no-repeat
                background-size 100% 100%
                margin-top 3rpx
            .cell1
                background-image url(./../../../assets/images/icons/icon_2.png)
            .cell2
                background-image url(./../../../assets/images/icons/icon_gy_2.png)
            .cell3
                background-image url(./../../../assets/images/icons/icon_gy_1.png)
            .cell4
                background-image url(./../../../assets/images/icons/icon_gy_7.png)
            .cell5
                background-image url(./../../../assets/images/icons/icon_gy_3.png)
            .cell6
                background-image url(./../../../assets/images/icons/icon_6.png)
            .cell7
                background-image url(./../../../assets/images/icons/icon_16.png)
            .cell8
                background-image url(./../../../assets/images/icons/icon_30.png)
            .cell9
                background-image url(./../../../assets/images/icons/my_9.png)
            .van-field__left-icon
                margin-right 6rpx
            .van-cell:not(:last-child)::after
                left 0
            .star
                color #E60000
            .van-field__label
                width 160rpx
            .van-field__error-message
                text-align right
    .option-con
        width 100%
        padding 14rpx
        padding-top 0
        position relative
        textarea
            height 132rpx
            width 100%
            border 1px solid #D7D7D7
            border-radius 5rpx
            padding 10rpx
        .iconbeizhu
            position absolute
            left 20rpx
            top 20rpx
            display none
    .group-item
        padding 10rpx 16rpx
        border-bottom 1px solid #F0F0F0
        .tit
            color #3495FB
            margin-bottom 15rpx
            .iconfont
                font-size 16rpx
                margin-right 10rpx
        .situation-types
            span
                height 30rpx
                background #F1F1F1
                border-radius 8rpx
                line-height 30rpx
                padding 0 12rpx
                display inline-block
                font-size 14rpx
                margin 0 6rpx 10rpx 0
        .evaluate
            .item
                margin-bottom 15rpx
                font-size 14rpx
                overflow hidden
                label
                    line-height 0rpx
                    width 145rpx
                    float left
                .van-rate
                    float left
                    margin-right 20rpx
                .tip
                    float left
        &.upload-con
            overflow hidden
            .file-list
                li
                    border-radius 4rpx
                    float left
                    margin-right 10rpx
                    width 80rpx
                    height 80rpx
                    position relative
                    img
                        width 80rpx
                        height 80rpx
                        border-radius 4rpx
                .rz-picter
                    ul
                        float left
                    .upload-icon
                        float left
                        width 80rpx
                        height 80rpx
                        position relative
                        .file-input
                            position absolute
                            left 0
                            top 0
                            width 100%
                            height 100%
                            opacity 0
                        .img-bg
                            background #f7f8fa
                            height 100%
                            border-radius 4rpx
                            text-align center
                            line-height 80rpx
                            .iconfont
                                color #dcdee0


</style>
<style>
.newMaterialPlan-box .van-collapse-item__title .van-cell__right-icon::before{
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
}
.newMaterialPlan-box .van-collapse-item__title--expanded .van-cell__right-icon::before{
    -webkit-transform: rotate(90deg);
    transform: rotate(90deg);
}
.newMaterialPlan-box input::-webkit-input-placeholder{
    color: #E60000;
}
</style>